module.exports = __webpack_public_path__ + "media/Video 25.0da207a7.mp4";